import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowBoldDown = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 21L20 11.5V11H15V3H9V11H4V11.5L12 21Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconArrowBoldDown.js.map